import { SHTable } from "@components/design-systems";
import { Theme } from "@emotion/react";
import { AnalysisSummaryDTO } from "@models/platform-analysis/entities/steps/summary";
import { styled, SxProps } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import { AnalysisSummaryStyleConfigs as Configs } from "../../../../configs";

export const SummaryPortfolioCompositionTableWrapper = styled(SHTable)(
  ({ theme: { palette } }) => {
    const { control } = useFormContext<AnalysisSummaryDTO>();

    const excludingSubTotals = useWatch({
      control,
      name: "hidePortfolioCompositionSubtotals",
    });

    const sxStyles: SxProps<Theme> = {
      thead: {
        th: {
          padding: "0px 0px !important",
          position: "relative",
          border: `1px solid ${palette.text.disabled}`,
          ":first-of-type": {
            minWidth: Configs.PortfolioCompositionTitleColumnWidth,
            maxWidth: Configs.PortfolioCompositionTitleColumnWidth,
          },
          minWidth: Configs.PortfolioCompositionDefaultColumnWidth,
          maxWidth: Configs.PortfolioCompositionDefaultColumnWidth,
        },
      },
      tbody: {
        tr: {
          td: {
            height: 40,
            padding: "10px 0px !important",
          },
          "&.PortfolioCompositionTableBodyRow": {
            borderLeft: `1px solid ${palette.text.disabled}`,
            borderRight: `1px solid ${palette.text.disabled}`,
            td: {
              backgroundColor: palette.secondary[50],
              borderTop: `1px solid ${palette.secondary[100]}`,
              borderRight: `1px solid ${palette.text.disabled}`,
              padding: "0px 0px !important",
              ":first-of-type": {
                paddingLeft: excludingSubTotals
                  ? "10px !important"
                  : "20px !important",
              },
            },
            ":first-of-type": {
              td: {
                borderTop: `1px solid ${palette.text.disabled}`,
              },
            },
            ":last-of-type": {
              borderBottom: `1px solid ${palette.text.disabled}`,
            },
            "&.SubTotalRow": {
              td: {
                backgroundColor: palette.common.white,
                border: `1px solid ${palette.text.disabled}`,
                borderBottom: "none",
                ":first-of-type": {
                  paddingLeft: "10px !important",
                },
              },
            },
            "&.SingleRow": {
              td: {
                borderTop: `1px solid ${palette.text.disabled}`,
                borderBottom: `1px solid ${palette.text.disabled}`,
                backgroundColor: palette.common.white,
                ":first-of-type": {
                  paddingLeft: "10px !important",
                },
              },
            },
          },
        },
      },
    };

    return sxStyles;
  },
);
